var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"oeamtc-app",class:{'oeamtc-app--navleft': _vm.showNavSidebar, 'remove-navbar-spacing': _vm.headerFooterHidden},attrs:{"id":"page"}},[_vm._t("default"),(_vm.showNavSidebar)?_c('navigation-sidebar'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }